import React, {Component} from 'react';
import {postSphereEngineSubmission} from '../../lib/api';

class CodeEditor extends Component {
    componentDidMount = async () => {
        
        setTimeout(() => {
            this.callEvent();
        }, 3000);
    }
    callEvent = async () => {
        try {
            console.log(window.SEC);
            var SEC = window.SEC;
            await SEC.ready(async function(){
                var checkStatus = async function (data) {
                    console.log(data);
                    if (data.statusDescription != 'running') {
                        let response = await postSphereEngineSubmission(data.apiSubmissionId);
                        console.log(response);
                    }
                }
                var SECWidget = SEC.widget("sec-widget");
                SECWidget.events.subscribe('checkStatus', checkStatus);
            })
        } catch (error) {
            console.log(error);
        }
        
    }
    render () {
        return (
            <div>
                <div style={{backgroundColor: '#eee', margin: 'auto',marginTop:'90px', border: '1px solid #ccc', height: '600px', width: '90%'}}>
                    <div id='sphere-engine-compiler-jssdk' class='sec-widget' data-id='sec-widget' data-widget="78c7bfb3d84b3ec745e900db4b779fec"></div>
                </div>
            </div>
        )
    }
}

export default CodeEditor;